import { render, staticRenderFns } from "./create-milestone.vue?vue&type=template&id=2c669ede&"
import script from "./create-milestone.vue?vue&type=script&lang=js&"
export * from "./create-milestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports